export default "__VITE_ASSET__BIs6xeJb__ 778w";